import { useRouterState } from "@tanstack/react-router";

/**
 * True on every settings route. A boolean select, so a subscriber re-renders
 * only when settings is entered or left — never on a navigation within either
 * world. The workspace layout's leaves and the module rail both read it: the
 * rail's collapsed-pane block grows a Settings chip there, because settings
 * has no module tile to preview its navigation from.
 */
export function useIsSettingsRoute(): boolean {
  return useRouterState({
    select: (s) => s.location.pathname.split("/").includes("settings"),
  });
}
